var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAndroid14(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 75,
    viewBox: "0 0 74 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_525",
    "data-name": "Group 525",
    transform: "translate(-937 -358)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_524",
    "data-name": "Group 524",
    transform: "translate(100 -65)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_157",
    "data-name": "Rectangle 157",
    width: 74,
    height: 75,
    rx: 6,
    transform: "translate(837 423)",
    fill: "#f86734"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Android",
    transform: "translate(944 377)",
    fill: "#fff",
    fontSize: 16,
    fontFamily: "HelveticaNeue-Bold, Helvetica Neue",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Android")), /*#__PURE__*/React.createElement("text", {
    id: "_14",
    "data-name": 14,
    transform: "translate(946 420.557)",
    fill: "#fff",
    fontSize: 50,
    fontFamily: "HelveticaNeue-Bold, Helvetica Neue",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "14")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid14);
export default __webpack_public_path__ + "static/media/android14.e80e98edf507e893c2555fb6e28878e5.svg";
export { ForwardRef as ReactComponent };